export default () => ({
  index: [],
});
